import {initializeApp} from 'firebase/app';
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import {getDatabase, ref as realtimeDBRef} from 'firebase/database';
import {
  getStorage,
  ref as storageRef,
  StorageReference,
  uploadBytesResumable,
  UploadMetadata,
} from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  databaseURL: process.env.REACT_APP_REALTIME_DATABASE_URL,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const storage = getStorage(app);

const realTimeDatabase = getDatabase(app);

export const firebaseLogin = (email: string, password: string) =>
  signInWithEmailAndPassword(auth, email, password);

export const createRealtimeDBRef = (path?: string) =>
  realtimeDBRef(realTimeDatabase, path);

export const createStorageRef = (path?: string) => storageRef(storage, path);

export const getUploadTask = (
  ref: StorageReference,
  data: Blob | Uint8Array | ArrayBuffer,
  metadata?: UploadMetadata,
) => uploadBytesResumable(ref, data, metadata);
